import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VTooltip from 'v-tooltip'
import VueI18n from 'vue-i18n'

import './registerServiceWorker'

import 'normalize.css'
import './global.scss'

import '@/assets/css/tailwind.css'
import '@/assets/css/tooltip.css'

Vue.use(VTooltip)
Vue.use(VueI18n)

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'es',
  messages: {
    es: {
      title: 'Mapa de las Religiones de Euskadi',
      desc: 'En este mapa interactivo se recoge la información referida a la pluralidad religiosa de la CAE, tanto en lo referido a la adscripción religiosa de la población como a la cantidad y ubicación de lugares de culto de cada confesión',
    },
    eu: {
      title: 'Euskadiko Erlijioen Mapa',
      desc: 'Mapa interaktibo horretan, EAEko erlijio-aniztasunari buruzko informazioa jasotzen da, bai herriaren erlijio-atxikipenari dagokionez, bai konfesio bakoitzaren kultu-lekuen kantitateari eta kokapenari dagokienez.',
    },
    en: {
      title: 'Map of the Religions of the Basque Country',
      desc: 'In this interactive map the information referring to the religious plurality of the CAE is collected, both in terms of the religious ascription of the population and the amount and location of places of worship of each confession.',
    },
    fr: {
      title: 'Carte des Religions du Pays Basque',
      desc: 'Sur cette carte interactive, les informations relatives à la pluralité religieuse des CAE sont collectées, tant en termes d´attribution religieuse de la population que de quantité et de localisation des lieux de culte de chaque confession.',
    },
  },
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
